const OFFER = 'offer'
const OVERDUE = 'overdue'

const PAYMENT_PURPOSE = {
  OFFER,
  OVERDUE,
}

export { PAYMENT_PURPOSE }
